import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LTApolicyService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    try{
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    }catch(e){}
  }

  ESS_ReimbursementRuleInsert(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReimbursementRuleInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  

  ESS_ReimbursementRule(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReimbursementRule/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

}
